<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th class="text-center">Criado por</th>
        <th>Nome</th>
        <th>Descrição</th>
        <th>Instrutor</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="course in courses" :key="course.id">
        <td class="text-center" v-html="typeCourse(course.type)" />
        <td>{{ course.name }}</td>
        <td>{{ course.description }}</td>
        <td>{{ course.instructor }}</td>
        <td class="text-center" v-html="statusTranslate(course.status)" />
        <td class="text-center">
          <router-link
            :to="`courses/${course.id}`"
            class="btn btn-outline-primary btn-icon rounded-pill"
            title="Detalhes"
          >
            <i class="ph-file-text" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { typeCourse, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListCourses',

  props: {
    courses: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListCourses',
        columnDefs: [
          {
            targets: [0],
            width: 150,
          },
          {
            targets: [2],
            width: 600,
          },
          {
            targets: [5],
            orderable: false,
            width: 100,
          },
        ],
      },
      typeCourse,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
